import React, { useEffect, useState } from 'react'
import * as THREE from "three"
import { Plane } from "@react-three/drei";

function ImagePlan({ logo,flickering }) {

    const [colorMap, setcolorMap] = useState(null)
    const [imgWH, setimgWH] = useState(null)
  
    const loader = new THREE.TextureLoader();

   useEffect(() => {
    let url=logo.url
    url=url.replace("https://cdnsit.wovvtech.com/image/","https://wovvmapimagesit.wovvtech.com/image/")
    loader.load(url, (texture) => {
      setcolorMap(texture)
      setimgWH({ w: texture.image.width, h: texture.image.height })
    },
      undefined,
      (err) => {
  
      }
    )
   }, [])

   
    
    if (!colorMap) {
      return null
    }
  
    return (
      <Plane
        args={[(logo.size / 10), ((logo.size * imgWH.h) / imgWH.w) / 10]}
        position={[(logo.x / 10) + (logo.size / 10) / 2, 3.1+flickering, (logo.y / 10) + (((logo.size * imgWH.h) / imgWH.w) / 10) / 2]}
        rotation={[-Math.PI / 2, 0, -(logo.rotate * Math.PI) / 180]}
      >
        <meshBasicMaterial
          map={colorMap}
          side={THREE.DoubleSide}
          transparent={true}
          color={"white"}
        />
      </Plane>
    );
  }
  

  export default ImagePlan